import type { TFunction } from "i18next";
import type { StepDisplayState } from "../../../api/threads/liveMessages";

/**
 * The one map of step-state words (W-05, DR-C-03), for the Workflow graph, its outline and the
 * Run view alike. Module C decides each step's state (W-22, `display_state`); this only names
 * it: F33's user states and T3 Code's names (F54). A step whose person gives an input first
 * reads Input, as one whose person step waits does; a turn waiting for a free slot reads
 * Waiting, as the Run's own status does.
 */
export const STEP_STATE_WORDS = ["upcoming", "ready", "input", "waitingForApproval", "offline", "waiting", "queued", "running", "done", "skipped", "failed"] as const;
export type StepStateWord = (typeof STEP_STATE_WORDS)[number];

const DISPLAY_WORD: Readonly<Record<StepDisplayState, StepStateWord>> = {
  upcoming: "upcoming",
  ready: "ready",
  needs_input: "input",
  input: "input",
  approval: "waitingForApproval",
  offline: "offline",
  slot: "waiting",
  queued: "queued",
  running: "running",
  done: "done",
  failed: "failed",
  skipped: "skipped",
};

/** A step's state in a Run, as module C shows it, in words: on the graph, its outline and the Run view's steps. */
export function stepStateText(state: StepDisplayState, t: TFunction): string {
  return t(`threads.stepStates.${DISPLAY_WORD[state]}`);
}
